import React from "react";
import "../styles/PurchaseInvoiceLayout.css";


const PurchaseInvoiceLayout = ({ leftContent, rightContent }) => {
  return (
    <div className="purchase-page-container">
      <div className="left-section">{leftContent}</div>
      <div className="right-section">{rightContent}</div>
    </div>
  );
};

export default PurchaseInvoiceLayout;
